import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_DELETE_ARTIST_SET_MUTATION = gql`
  mutation Post(
    $id: String!,
    $artistSetSlugName: String!,
    ) {
    postDeleteArtistSet(
      id: $id,
      artistSetSlugName: $artistSetSlugName,
      ) {
      isAuth
      isDeleted
      artistSetSlugName
      isUsed { eventSlugNames }
    }
  }
`;

const postDeleteArtistSet = async ({
  id,
  artistSetSlugName,
}) => {
  try {
    const result = await client.mutate({
      mutation: POST_DELETE_ARTIST_SET_MUTATION,
      variables: {
        id,
        artistSetSlugName,
      },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { postDeleteArtistSet: postDeleteArtistSetValidationData } } = result;

    if (postDeleteArtistSetValidationData) {
      return postDeleteArtistSetValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postDeleteArtistSetValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postDeleteArtistSet Error: ${error}`);
    return null;
  }
};

export default postDeleteArtistSet;
